module.exports = __webpack_public_path__ + "img/success.61b8a3cb.png";